import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { EmployeesService, IGraphUser, ImageService } from '@app/core';
import { DxTagBoxComponent } from 'devextreme-angular/ui/tag-box';

@Component({
    selector: 'app-employee-picker',
    templateUrl: './employee-picker.component.html',
    styleUrls: ['./employee-picker.component.scss'],
})
export class EmployeePickerComponent implements OnInit {

    @ViewChild('multipleTagsBox')
    public multipleTagsBox: DxTagBoxComponent;
    @ViewChild('singleTagBox')
    public singleTagBox: DxTagBoxComponent;

    @Input()
    public readOnly: boolean = false;

    @Input()
    public isRequired: boolean = false;

    @Input()
    public multiple: boolean = false;

    @Input()
    public selectedItem: IGraphUser;

    @Input()
    public selectedItems: IGraphUser[];

    @Output()
    public selectedItemChange = new EventEmitter<IGraphUser>();

    @Output()
    public selectedItemsChange = new EventEmitter<IGraphUser[]>();

    @Output()
    public selectionCleared = new EventEmitter<void>();

    public employees: IGraphUser[] = [];

    public searchFilter: string = '';
    private timeOut: number;

    private previousSingleValue: IGraphUser;

    constructor(private service: EmployeesService, private imageService: ImageService) {
        this.loadDataSource = this.loadDataSource.bind(this);
    }

    public ngOnInit(): void {
        this.selectedItems = this.selectedItems || [];
    }

    /**
     * Search filter changed
     * @param e Handle event
     */
    public onSearchFilterChanged(e): void {
        if (this.timeOut) {
            window.clearTimeout(this.timeOut);
        }
        this.timeOut = window.setTimeout(this.loadDataSource, 1000);
    }

    public loadDataSource(): void {
        if (this.multiple) {
            this.multipleTagsBox.instance.close();
        }
        else {
            this.singleTagBox.instance.close();
        }
        this.employees = [];

        if (this.searchFilter.length > 0) {
            this.readOnly = true;
            this.service.getEmployeesStartWith(this.searchFilter).subscribe(emps => {
                this.employees = emps;
                this.employees.forEach(emp => {
                    this.imageService.get(emp.id).subscribe(photo => emp.photo = photo);
                });
                this.readOnly = false;
                if (this.multiple) {
                    this.multipleTagsBox.instance.open();
                }
                else {
                    this.singleTagBox.instance.open();
                }
            });
        }
    }

    public onSingleValueChange($event: IGraphUser): void {
        if (this.previousSingleValue === $event) { return; }
        if ($event == null) {
            this.selectionCleared.emit();
            return;
        }

        this.selectedItemChange.emit($event);
        this.selectedItem = null;
    }

    public onMultipleValueChange($event: IGraphUser[]): void {
        if ($event == null) { return; }

        this.selectedItemsChange.emit($event);
        this.selectedItems = $event;
    }

    public displayName(data: any): string {
        if (data) {
            return data.displayName ? data.displayName : data.name;
        } else {
            return '';
        }
    }
}
